import React, { forwardRef, useCallback } from "react";
import CourtSvg1 from "./CourtSvg1";
import DeployedTokens from "./DeployedTokens";
import { ZoneSvgs } from "./OuterCourt.data";
import styles from './court.module.css'

const ACTION_IMAGE_SIZE = 150; 

const OuterCourt = forwardRef(({ courtOuterSvgId, viewBox, currentCommentary, showZoneOnMobileScreen, makeSelectable, showHoveredTooltip, selectedZones, zonesToBeHighlighted, hideZoneName, isLiveGame = false, teamDetails, isDeployTokenPage = false, hideHover = false, purchasedTokens, disableTokenHover=false }, svgRef) => {
  const _selectedZone = useCallback((_zone, checkForLastIndex) => {
    if(checkForLastIndex) {
      if (zonesToBeHighlighted && zonesToBeHighlighted?.length > 0) {
        return zonesToBeHighlighted[zonesToBeHighlighted?.length - 1] === _zone
      }
      return false;
    }

    if (zonesToBeHighlighted && zonesToBeHighlighted?.length > 0) {
      return zonesToBeHighlighted?.find(z => z === _zone)
    }

    if (selectedZones && selectedZones?.length > 0) {
      return selectedZones?.find(z => z === _zone)
    }

  }, [zonesToBeHighlighted, selectedZones]);

  return (
    <svg
      id={courtOuterSvgId}
      viewBox={`${viewBox.x} ${viewBox.y} ${viewBox.w} ${viewBox.h}`}
      ref={svgRef}
      fill="none"
      width="100%"
      height="100%"
      style={{ overflow: "visible" }} // Ensure team names outside are visible
    >
      <CourtSvg1
        showHoveredTooltip={showHoveredTooltip}
        makeSelectable={makeSelectable}
        _selectedZone={_selectedZone}
        hideZoneName={hideZoneName}
        isLiveGame={isLiveGame}
        teamDetails={teamDetails}
        hideHover={hideHover}
        showZoneOnMobileScreen={showZoneOnMobileScreen}
        currentCommentary={currentCommentary}
      />

      {purchasedTokens && purchasedTokens?.length > 0 && (isDeployTokenPage || isLiveGame) && (
        <DeployedTokens purchasedTokens={purchasedTokens} disableTokenHover={disableTokenHover} />
      )}

      {ZoneSvgs?.map((zone, key) => {
        if(isLiveGame && _selectedZone(zone?.zoneNumber?.toString(), true) && currentCommentary?.selectedActionImageofPlayers) {
          return (
            <foreignObject
              key={key}
              x={parseFloat(zone?.selectedZoneAction_X_Axis) - (ACTION_IMAGE_SIZE / 2)}
              y={parseFloat(zone?.selectedZoneAction_Y_Axis) - (ACTION_IMAGE_SIZE / 2)}
              className={styles.action_image_container}
              width={ACTION_IMAGE_SIZE}
              height={ACTION_IMAGE_SIZE}
            >
                <img
                  src={currentCommentary?.selectedActionImageofPlayers}
                  className={styles.actionImage}
                />
            </foreignObject>
          )
        }
        return null;
      })}

      {/* {purchasedTokens?.length > 0 && isLiveGame && (
        <DeployedTokens purchasedTokens={purchasedTokens} />
      )} */}

    </svg>
  );
});

OuterCourt.displayName = "OuterCourt";

export default OuterCourt;
